// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * @packageDocumentation https://learn.microsoft.com/azure/cognitive-services/openai/overview
 */
